export const state = () => ({
	privileges: [],
	media: [],
	totalMediaItems: null,
});

export const mutations = {
	privileges(state, payload) {
		state.privileges = payload;
	},
	media(state, payload) {
		state.media = payload;
	},
	totalMediaItems(state, payload) {
		state.totalMediaItems = payload;
	},
};

export const getters = {
	isAuthenticated(state) {
		return state.auth.loggedIn;
	},
	loggedInUser(state) {
		return state.auth.user;
	},
	privileges(state) {
		return state.privileges;
	},
	media(state) {
		return state.media;
	},
	totalMediaItems(state) {
		return state.totalMediaItems;
	},
};
